'use strict';

angular.module('mean.bids').controller('BidMaterialProfileController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', '$location', 'Materials', 'BidMaterialsSaves', 'tradeCodeService', 'userService', 'ngDialog', 'toaster',
    function ($scope, MeanUser, Global, Bids, $filter, $location, Materials, BidMaterialsSaves, tradeCodeService, userService, ngDialog, toaster) {
        $scope.global = Global;

        $scope.saved_task_list = [];
        $scope.material_profile_name = '';
        $scope.selected_material_profile = '';
        $scope.material_profiles = [];
        $scope.equipment_profile_name = '';
        $scope.selected_equipment_profile = '';
        $scope.equipment_profiles = [];
        $scope.profiles = [];

        console.log('bid material profiles');

        userService.getMainAccount(MeanUser.user.username).then(function (main_user) {
            BidMaterialsSaves.query({
                'user': main_user._id,
                projectType: $scope.bid.projectType,
                geoLocation: $scope.bid.geoLocation
            }, function (profiles) {
                _.each(profiles, function (profile) {
                    //originally the name would be of the form <name string> - <date>
                    //the user could enter dashes in the name.  Now we need to split
                    //<name string> and <date> and store in their own parameters.
                    //first lets split the name and check the last array element.
                    //if the last element is a date and the date parameter does
                    //not exist, then create the new name and the date parameter and save.
                    var array = profile.name.split('-');
                    var date_obj = new Date(array[array.length - 1]);
                    if (angular.isDate(date_obj) && angular.isUndefined(profile.date)) {
                        profile.name = '';
                        //recreate the name and put back in the dashes
                        for (var i = 0; i < array.length - 1; i++) {
                            profile.name += array[i];
                            if (i < array.length - 2) {
                                profile.name += '-';
                            }
                        }

                        //store the date portion from the original name
                        profile.date = date_obj;

                        profile.$update(function (success) {
                            success.formatted_date = $filter('date')(success.date, "ddMMMyyyy");
                            $scope.profiles.push(success);
                        }, function (error) {
                            toaster.pop('error', 'Profile Save Error', error);
                            return;
                        });
                    } else {
                        profile.formatted_date = $filter('date')(profile.date, "ddMMMyyyy");
                        $scope.profiles.push(profile);
                    }
                });
            });
        });

        $scope.onSelect = function () {
            console.log('onSelect function');
        };

        $scope.loadMaterialProfile = function () {
            var my_bids = this.$parent.$parent.my_bid;

            // my_bids.bid.forEach(function(bid) {
            //     bid.materials = [];
            //     bid.equipment = [];
            // });

            my_bids.inclusions = this.selected_material_profile.inclusions;
            my_bids.exclusions = this.selected_material_profile.exclusions;
            my_bids.costs = this.selected_material_profile.costs;
            this.$parent.$parent.my_inclusions = my_bids.inclusions;
            this.$parent.$parent.my_exclusions = my_bids.exclusions;
            this.$parent.$parent.company_factors = my_bids.costs;

            var my_tasks = $filter('filter')(this.$parent.my_bid.task_list, { 'trade': $scope.getTradeCode(MeanUser.user.trade[0]) }, true);
            //var my_tasks = this.$parent.filtered_task_list;
            var selected_tasks = this.selected_material_profile.task_list;

            for (var i = 0; i < my_tasks.length; i++) {
                var task = my_tasks[i];
                var profile = $filter('filter')(selected_tasks, { 'trade': task.trade, 'task': task.task }, true)[0];

                task.subtasks = [];
                for (var j = 0; j < profile.subtasks.length; j++) {
                    task.subtasks[j] = profile.subtasks[j];
                }
            }

            this.$parent.applayCalculations(my_tasks);

            this.$parent.my_bid.$update();
        };

        $scope.loadOperation = function () {
            ngDialog.openConfirm({
                template:
                    '<h2>Import Previous Bid Data</h2>' +
                    '<p>This will load the following from the bid you have selected:</p>' +
                    '<p>all selected subtasks and their asscociated rates, all selected material and ' +
                    'their associated rates, all equipment and their associated rates, all equipment and' +
                    'their associated rates, all items from the Specs Tab, and all trade rates that where' +
                    'inputted on that bid.  This will overide anything you have done to this point and' +
                    'their is no way to re-do the load.</p>' +
                    '<p>Are you sure you want to load this bid? </p>' +
                    '<div>' +
                    '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                    '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                    '</button></div>',
                plain: true,
                className: 'ngdialog-theme-default'
            }).then(function (value) {
                // perform delete operation
                $scope.loadMaterialProfile();
            }, function (value) {
                //Do something
                console.log('in the do something section');
            });
        };

        $scope.getTradeString = function (trade) {
            return tradeCodeService.getName(trade);
        };

        $scope.getTradeCode = function (trade) {
            return tradeCodeService.getCode(trade);
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidmaterialprofile.js